import texts from '@components/BondDirectoryFeature/en.json';
import { Text } from '@ui/atoms';
import { useBondDirectoryContext } from '../context/bond-directory-context';
import BondsSearchBar from './BondsSearchBar';
import BondSearchModal from './BondSearchModal';
import BondResults from './BondResults';
import Button from '@ui/atoms/design-system/Button';
import { buttonSizes, buttonTypes } from '@ui/atoms/utils/enums';
import { cn } from '@ui/atoms/utils/utils';
import useWindowDimensions from '@hooks/useWindowDimensions';

const BondDirectorySearchView = () => {
    const { title, description } = texts;

    const { width } = useWindowDimensions();

    const {
        showResults,
        showSuggestions,
        showSearchModal,
        onSubmit,
        loading,
        value,
    } = useBondDirectoryContext(({ states, callbacks }) => ({
        showResults: states.showResultsPage,
        showSuggestions: states.suggestions.showSuggestions,
        showSearchModal: states.showSearchModal,
        onSubmit: callbacks.handleOnSubmit,
        onOpenSearchModal: callbacks.onOpenSearchModal,
        loading: states.loading.searchButton,
        value: states.searchQuery,
    }));

    return (
        <div className="max-w-[720px] xl:max-w-[1152px] mx-auto relative z-20">
            <form
                onSubmit={onSubmit}
                className={cn(
                    'flex flex-col items-start mt-8 gap-9 md:items-start max-w-[882px] relative',
                    {
                        'mt-0': showResults,
                    }
                )}
            >
                <div
                    className={cn('flex-col gap-3', {
                        hidden: showResults && width < 768,
                    })}
                >
                    <Text
                        content={title}
                        className="text-left text-basicWhite h2-semibold md:h3-semibold xl:h2-semibold"
                        isInnerHtml
                        htmlTag="h1"
                    />
                    <Text
                        content={description}
                        className="text-left text-basicWhite p5-regular md:p4-regular"
                        isInnerHtml
                    />
                </div>
                <div className="flex flex-col w-full gap-2">
                    <div className="relative flex items-center w-full gap-3">
                        <BondsSearchBar id={'bondSearch'}>
                            {showSuggestions && width >= 768 && (
                                <div
                                    className="hidden shadow-xl md:inline-block absolute top-14 left-0 right-0 rounded-lg overflow-auto h-auto max-h-[224px] z-100 bg-basicWhite"
                                    id="scrollableDiv"
                                >
                                    <BondResults />
                                </div>
                            )}
                        </BondsSearchBar>
                        <Button
                            type="submit"
                            buttonSize={buttonSizes.LARGE}
                            buttonText="Search"
                            buttonType={buttonTypes.TERTIARY}
                            className="hidden md:inline-flex"
                            widthClass={'max-w-[120px] w-full'}
                            disabled={loading || !value}
                        />
                        {showSearchModal && <BondSearchModal />}
                    </div>
                </div>
            </form>
        </div>
    );
};

export default BondDirectorySearchView;
